import { PermissionedRoutes } from "@components/PermissionedRoutes";
import { RouteObject } from "react-router-dom";

export const APPLICATION_CONFIGURATION_ROUTES: RouteObject[] = [
  {
    element: (
      <PermissionedRoutes
        requiredPermissions={["backoffice.manage_application_outcomes_and_reasons"]}
        requiredFeatures={["new_account_opening", "application_decisioning"]}
      />
    ),
    children: [
      {
        index: true,
        async lazy() {
          const { ApplicationSettings } = await import("./ApplicationSettings");
          return {
            element: <ApplicationSettings />,
          };
        },
      },
      {
        path: "approved_outcome_reasons",
        async lazy() {
          const { OutcomeReasonsListPage } = await import("./outcomes/OutcomeReasonsListPage");

          return {
            element: <OutcomeReasonsListPage outcome="approved" />,
          };
        },
      },
      {
        path: "denied_outcome_reasons",
        async lazy() {
          const { OutcomeReasonsListPage } = await import("./outcomes/OutcomeReasonsListPage");

          return {
            element: <OutcomeReasonsListPage outcome="denied" />,
          };
        },
      },
    ],
  },
];
